export default "__VITE_ASSET__DH59rnTF__"